<template>
  <div id="layout-footer">
    <div class="content-section layout-footer">
      <span>Released under the MIT License</span>
      <div class="footer-links">
        <a href="https://github.com/sudheerj/vueface"><i class="fa fa-github"></i></a>
        <a href="https://twitter.com/SudheerJonna"><i class="fa fa-twitter"></i></a>
      </div>
   </div>
  </div>
</template>

<script>
  export default {
    name: 'footer-layout'
  };
</script>



// WEBPACK FOOTER //
// showcase/src/components/footer.vue